import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import Coupon from './CouponArea';
import CheckoutArea from './CheckoutArea';

const CheckoutMain = () => {
  return (
    <main>
      <Breadcrumb title="Checkout" />
      <Coupon />
      <CheckoutArea />
    </main>
  );
};

export default CheckoutMain;
